// extracted by mini-css-extract-plugin
export default {"errorBlock":"UpdateStatus_errorBlock__Nb4kN","updateProgress":"UpdateStatus_updateProgress__0LJqA","updateStatus":"UpdateStatus_updateStatus__UipQO"};